import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import CustomCard from "../CustomCard";

import Frame from "../../../assets/images/WallDecoratives/PhotoFrame.jpg";
import Board from "../../../assets/images/WallDecoratives/NeonLetterBoard.jpg";
import AcrylicFrame from "../../../assets/images/WallDecoratives/AcrylicSandwich.jpg";

// Card Data
const cardData = [
  { image: Frame, text: "Multi Pic Photo Frames" },
  { image: Board, text: "Neon Letter Boards" },
  { image: AcrylicFrame, text: "Acrylic Sandwich" },
];

function HomeSection2() {
  return (
    <>
      <Container className="mt-4 w-100 p-0">
        <h2 className="py-4 fw-bold text-center">Wall Decoratives</h2>
        <Row>
          {/* First row */}
          <Col md={6} className="d-flex">
            <CustomCard image={cardData[0].image} text={cardData[0].text} />
          </Col>
          <Col md={3} className="d-flex">
            <CustomCard image={cardData[1].image} text={cardData[1].text} />
          </Col>
          <Col md={3} className="d-flex">
            <CustomCard image={cardData[2].image} text={cardData[2].text} />
          </Col>
        </Row>

        {/* Divider-line */}
        <hr className="divider-line" style={{ margin: "0 auto" }} />
      </Container>
    </>
  );
}

export default HomeSection2;
